import $ from 'jquery';
import _ from 'lodash';


$('.js-site-search-form').submit(event => {
  event.preventDefault();
  const form = $(event.currentTarget).serializeArray();
  const query = _.find(form, { name: 'query' }).value;
  const searchPage = $(event.currentTarget).data('search-page');
  if (query.length) {
    window.location.href =
      searchPage + '/?query=' + encodeURIComponent(query);
  }
});
